<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large>
          store
        </v-icon>
        <h2 class="display-2 my-2">
          Deine Kegelbahn
        </h2>
      </v-col>
    </v-row>
    <page-loading :is-page-loading="$store.state.pageLoading" />

    <v-row
      align="start"
      justify="center"
      class="mb-12"
    >
      <v-col
        cols="12"
        sm="12"
      >
        <v-card
          color="primary"
          raised
        >
          <v-row
            align="center"
            class="mx-0"
          >
            <v-col
              class="text-center"
              align-self="start"
            >
              <v-chip dark class="title mb-8 mt-4 px-8">
                {{ $store.state.kegelbahnStore.kegelbahn.name }}
              </v-chip>

              <v-avatar
                size="100%"
                class="grey lighten-4 elevation-4"
              >
                <v-img
                  :src="$store.state.kegelbahnStore.imageURL + $store.state.kegelbahnStore.kegelbahn.nr + '.png'" alt="avatar"
                  aspect-ratio="1"
                />
              </v-avatar>
            </v-col>

            <v-col
              cols="12"
              sm="9"
            >
              <div class="white pa-4">
                <div>
                  <h3 class="headline">
                    Name: {{ $store.state.kegelbahnStore.kegelbahn.name }}
                  </h3>
                  <div class="subtitle-1">
                    {{ $store.state.kegelbahnStore.kegelbahn.text }}
                  </div>
                </div>
                <hr class="mt-2 mb-2">
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <h3 class="title mb-4">
                      Kegelbahnwerte:
                    </h3>
                    <ul class="mb-6">
                      <li>
                        der Anschaffungspreis lag bei
                        <strong v-if="$store.state.kegelbahnStore.kegelbahn.nr > 0">
                          {{ $store.state.kegelbahnStore.kegelbahn.kosten | currency }}
                        </strong>
                        <strong v-else>€ 0</strong>
                      </li>
                      <li>der Bau dauerte <strong>{{ $store.state.kegelbahnStore.kegelbahn.dauer }} Spieltage</strong></li>
                      <li>der Heim-Index von jedem Spieler verändert sich um <strong>{{ $store.state.kegelbahnStore.kegelbahn.heimIndex }} Punkte</strong></li>
                    </ul>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    text-center
                  >
                    <h3 class="title mb-2">
                      Kegelbahnzustand:
                    </h3>
                    <v-progress-circular
                      :size="100"
                      :width="15"
                      :rotate="-90"
                      :value="zustand"
                      :color="zustand | getStatusColor"
                    >
                      {{ zustand }} %
                    </v-progress-circular>
                    <div v-show="zustand < 100">
                      Deine Kegelbahn könnte eine Reperatur gebrauchen:<br>
                      <strong>
                        Kosten: {{ repairCost($store.state.kegelbahnStore.kegelbahn) | currency }} / Reperatur
                      </strong>
                      <v-btn
                        :loading="$store.state.loading"
                        :disabled="$store.state.loading"
                        color="primary"
                        @click.native="repairMyKegelbahn"
                      >
                        reparieren
                        <v-icon right dark>
                          mdi-wrench
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-col>

                  <v-col
                    cols="12"
                  >
                    <h3 class="title">
                      <v-icon large>
                        mdi-trophy-award
                      </v-icon> Bahnrekorde:
                    </h3>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        align-self="stretch"
                      >
                        <v-card
                          class="mx-auto"
                          dark
                        >
                          <v-card-title
                            primary-title
                            class="title text-center"
                          >
                            <v-row>
                              <v-col cols="12">
                                Einzelrekord
                              </v-col>
                              <v-col cols="12">
                                {{ einzelrekord.ergebnis }} Kegel
                              </v-col>
                              <v-col cols="12">
                                {{ einzelrekord.name }} ({{ einzelrekord.teamname }})
                              </v-col>
                            </v-row>
                          </v-card-title>
                          <v-divider />

                          <v-card-text
                            class="text-center"
                          >
                            <v-row>
                              <v-col cols="12" class="pa-1">
                                {{ einzelrekord.saison.name }} - Spieltag {{ einzelrekord.saison.spieltag }}
                              </v-col>
                              <v-col cols="12" class="pa-1">
                                {{ einzelrekord.datum }}
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="6"
                        align-self="stretch"
                      >
                        <v-card
                          class="mx-auto"
                          dark
                        >
                          <v-card-title
                            primary-title
                            class="title text-center"
                          >
                            <v-row>
                              <v-col cols="12">
                                Mannschaftsrekord
                              </v-col>
                              <v-col cols="12">
                                {{ mannschaftsrekord.ergebnis }} Kegel
                              </v-col>
                              <v-col cols="12">
                                {{ mannschaftsrekord.teamname }}
                              </v-col>
                            </v-row>
                          </v-card-title>
                          <v-divider />
                          <v-card-text
                            class="text-center"
                          >
                            <v-row>
                              <v-col cols="12" class="pa-1">
                                {{ mannschaftsrekord.saison.name }} - Spieltag {{ mannschaftsrekord.saison.spieltag }}
                              </v-col>
                              <v-col cols="12" class="pa-1">
                                {{ mannschaftsrekord.datum }}
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      v-if="$store.state.kegelbahnStore.ausbau.inBau"
      class="my-6"
    >
      <v-col cols="12">
        <h2 class="header text-center">
          Deine neue Kegelbahn ist bald fertig:
        </h2>
        <v-card
          raised
          color="lime lighten-2"
        >
          <v-row>
            <v-col
              cols="12"
              sm="3"
            >
              <v-avatar
                size="100%"
                class="grey lighten-4"
              >
                <v-img
                  :src="$store.state.kegelbahnStore.imageURL + $store.state.kegelbahnStore.ausbau.kegelbahn.nr + '.png'"
                  alt="avatar"
                  aspect-ratio="1"
                />
              </v-avatar>
            </v-col>

            <v-col
              cols="12"
              sm="9"
            >
              <div class="white pa-4">
                <div>
                  <h3 class="headline">
                    Name: {{ $store.state.kegelbahnStore.ausbau.kegelbahn.name }}
                  </h3>
                  <div class="subtitle-1">
                    {{ $store.state.kegelbahnStore.ausbau.kegelbahn.text }}
                  </div>
                </div>
                <hr class="mt-2 mb-2">
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <h3 class="title mb-4">
                      Kegelbahnwerte:
                    </h3>
                    <ul class="mb-6">
                      <li>
                        der Anschaffungspreis lag bei
                        <strong>{{ $store.state.kegelbahnStore.ausbau.kegelbahn.kosten | currency }}</strong>
                      </li>
                      <li>
                        der Bau dauert insgesamt
                        <strong>{{ $store.state.kegelbahnStore.ausbau.kegelbahn.dauer }} Spieltage</strong>
                      </li>
                      <li>
                        der Heim-Index von jedem Spieler verändert sich um
                        <strong>{{ $store.state.kegelbahnStore.ausbau.kegelbahn.heimIndex }} Punkte</strong>
                      </li>
                    </ul>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    text-center
                  >
                    <h3 class="title mb-2">
                      Ausbaustand: {{ $store.getters['kegelbahnStore/ausbauStatus'] }}%
                    </h3>
                    <v-progress-linear
                      v-model="$store.getters['kegelbahnStore/ausbauStatus']"
                      height="13"
                    />
                    {{ $store.getters['kegelbahnStore/ausbauStatusText'] }}
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      v-if="!$store.state.kegelbahnStore.ausbau.inBau"
      class="mt-12"
      justify="center"
    >
      <v-col
        cols="12"
        class="text-center"
      >
        <h2 class="header">
          Kegelbahnen die Du kaufen kannst, wenn Du genug Geld hast.
        </h2>
      </v-col>
      <v-col
        v-show="item.nr > 0 && item.nr != $store.state.kegelbahnStore.kegelbahn.nr"
        v-for="item in kegelbahnen"
        :key="item._id"
        cols="12"
        sm="12"
        class="mb-6"
      >
        <v-card
          outlined
          color="primary lighten-2"
        >
          <v-row
            align="center"
            class="mx-0"
          >
            <v-col
              class="text-center"
              align-self="stretch"
            >
              <v-avatar
                size="100%"
                class="grey lighten-4 elevation-4"
              >
                <v-img
                  :src="$store.state.kegelbahnStore.imageURL + item.nr + '.png'"
                  alt="avatar"
                  aspect-ratio="1"
                />
              </v-avatar>
            </v-col>
            <v-col
              cols="12"
              sm="9"
            >
              <div class="white pa-4">
                <div>
                  <h3 class="headline">
                    Name: {{ item.name }}
                  </h3>
                  <div class="subtitle-1">
                    {{ item.text }}
                  </div>
                </div>
                <hr class="mt-2 mb-2">
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <h3 class="title mb-4">
                      Kegelbahnwerte:
                    </h3>
                    <ul class="mb-6">
                      <li>
                        der Anschaffungspreis liegt bei
                        <strong v-if="item.nr > 0">
                          {{ item.kosten | currency }}
                        </strong>
                        <strong v-else>€ 0</strong>
                      </li>
                      <li>der Bau dauert <strong>{{ item.dauer }} Spieltage</strong></li>
                      <li>der Heim-Index von jedem Spieler verändert sich um <strong>{{ item.heimIndex }} Punkte</strong></li>
                    </ul>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    text-center
                  >
                    <div v-if="$store.state.moneyStore.giro > item.kosten">
                      <v-btn
                        :loading="$store.state.loading"
                        :disabled="$store.state.loading"
                        color="primary"
                        @click.native="byNewKegelbahn(item._id)"
                      >
                        kaufen
                        <v-icon right dark>
                          mdi-cash-100
                        </v-icon>
                      </v-btn>
                    </div>
                    <div v-else>
                      Du hast nicht genug Geld auf deinem Konto, um Dir diese Kegelbahn zu kaufen
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Kegelbahn',
  metaInfo: {
    title: 'Kegelbahn'
  },
  data () {
    return {
      kegelbahnen: [],
      zustand: 100,
      einzelrekord: {
        ergebnis: 0,
        name: '',
        teamname: '',
        saison: '',
        datum: ''
      },
      mannschaftsrekord: {
        ergebnis: 0,
        teamname: '',
        saison: '',
        datum: ''
      }
    }
  },
  methods: {
    byNewKegelbahn: async function (carId) {
      // Fahrzeug kaufen
      await this.$store.dispatch('kegelbahnStore/byNewKegelbahn', carId)
    },
    repairMyKegelbahn: async function () {
      if (this.zustand < 100) {
        // dispatch zustand in fahrzeug store
        if (await this.$store.dispatch('kegelbahnStore/repairMyKegelbahn')) {
          // set new zustand
          this.zustand = this.$store.state.kegelbahnStore.kegelbahn.zustand
        }
      }
    },
    repairCost: function (item) {
      return Math.ceil(item.kosten * item.repair_cost)
    }
  },
  mounted: async function () {
    // load changelogs in store from cache or from server if cache is not valid
    if (await this.$store.dispatch('kegelbahnStore/getAllKegelbahnen')) {
      this.kegelbahnen = this.$store.state.kegelbahnStore.kegelbahnen
      this.zustand = this.$store.state.kegelbahnStore.kegelbahn.zustand
      this.einzelrekord = {
        ergebnis: this.$store.state.kegelbahnStore.kegelbahn.rekord.einzel.ergebnis || 0,
        name: this.$store.state.kegelbahnStore.kegelbahn.rekord.einzel.name || '',
        teamname: this.$store.state.kegelbahnStore.kegelbahn.rekord.einzel.user.teamname || '',
        saison: {
          name: this.$store.state.kegelbahnStore.kegelbahn.rekord.einzel.saison.name || '',
          spieltag: this.$store.state.kegelbahnStore.kegelbahn.rekord.einzel.saison.spieltag || ''
        },
        datum: this.$store.state.kegelbahnStore.kegelbahn.rekord.einzel.date || ''
      }
      this.mannschaftsrekord = {
        ergebnis: this.$store.state.kegelbahnStore.kegelbahn.rekord.ergebnis || 0,
        teamname: this.$store.state.kegelbahnStore.kegelbahn.rekord.user.teamname || '',
        saison: {
          name: this.$store.state.kegelbahnStore.kegelbahn.rekord.saison.name || '',
          spieltag: this.$store.state.kegelbahnStore.kegelbahn.rekord.saison.spieltag || ''
        },
        datum: this.$store.state.kegelbahnStore.kegelbahn.rekord.date || ''
      }
    }
  }
}
</script>
<style scoped>
ul{
  margin-left: 2%;
}
</style>
